jQuery(document).ready(function(){
   new Swiper('.main-images-options.swiper-container', {
      loop: false,
      lazy: true,
      slidesPerView: 1,
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function(index, className) {
          return `<span class="outer-dot swiper-pagination-bullet" data-index="${
            index + 1
          }"><span class="inner-dot"></span></span>`;
        }
      },
      on: {
            slideChange: function () {
                let updatedIndex = this.realIndex + 1; // 1-based index
                $('.swiper-slider-current-slide .current-slide').html('Current Slide: ' + updatedIndex);
                // Update pagination bullets
                $('.swiper-pagination-bullet').removeClass('swiper-pagination-bullet-active');
                // Update only the bullet corresponding to the current slide
                $('.swiper-pagination-bullet[data-index="' + updatedIndex + '"]').addClass('swiper-pagination-bullet-active');
            }
        }
  });

 let mySwiper = null;

 //  // Function to initialize Swiper
  function initializeSwiperIfNeeded() {
    const slides = document.querySelectorAll('.thumbnails-options-main .thumb-img.swiper-slide.showThis');
    const container = document.querySelector('.thumbnails-options-main.swiper-container');

    if (slides.length >= 4) {
        mySwiper = new Swiper(container, {
          slidesPerView: 5,
          spaceBetween: 10,
          direction: 'vertical',
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
    } else {
      alert('destroy');
      destroySwiperIfNeeded();
    }

  }

  // Function to destroy Swiper if needed
  function destroySwiperIfNeeded() {
    if (mySwiper) {
      alert('Destroying Swiper');
      mySwiper.destroy(true, true);
      mySwiper = null;
    }
  }

  // Swatch click listener
  document.querySelectorAll('.pdp-custom-swatch-list-item').forEach(button => {
    button.addEventListener('click', () => {
      setTimeout(() => {
        initializeSwiperIfNeeded();
      }, 2000); // Wait for DOM updates
    });
  });

   var color2 = $('.pdp-swch-img').attr('datache').toLowerCase();
   jQuery('.thumbnails-options .thumb-img[data-alt="'+color2+'"]').show();
   jQuery('.thumbnails-options .thumb-img[data-alt!="'+color2+'"]').hide();
   $('.products-images-sections .thumbnails-options .thumb-img:first-child').addClass('thumb-img-active');
   jQuery(document).on('click', '.pdp-swch-img', function() {
            var color = jQuery(this).attr('datache').toLowerCase();
            const thumbImages = document.querySelectorAll('.thumb-img');
            let matchedIndex = -1;
            for (let index = 0; index < thumbImages.length; index++) {
                const thumbImg = thumbImages[index];
                if (thumbImg.getAttribute('data-alt').toLowerCase() === color) {
                    matchedIndex = index; // Store the index of the first matched image
                    break; // Exit the loop after the first match
                }
            }
            if (matchedIndex !== -1) {
                jQuery('.thumbnails-options .thumb-img').hide();
                const matchingThumbs = jQuery('.thumbnails-options .thumb-img[data-alt="' + color + '"]');
                matchingThumbs.show();
                matchingThumbs.removeClass('thumb-img-active');
                matchingThumbs.first().addClass('thumb-img-active');
            }
            
    });
    $(document).on('click', '.pdp-custom-swatch-list-item', function() {
          $('.pdp-custom-swatch .pdp-custom-swatch-list-item').removeClass('active');
          let selectedColor = $(this).attr('data-color');
          $(this).addClass('active');
          updatepdpImg(selectedColor);
    });
    function updatepdpImg(selectedColor) {
        $('.current-main-images .thumb-img[data-alt="' + selectedColor + '"]').addClass('showThis');
        $('.current-main-images .thumb-img[data-alt!="' + selectedColor + '"]').removeClass('showThis');
        $('.thumbnails-options .thumb-img[data-alt="' + selectedColor + '"]').addClass('showThis');
        $('.thumbnails-options .thumb-img[data-alt!="' + selectedColor + '"]').removeClass('showThis');
        $('.thumbnails-options .thumb-img.showThis').each(function(i) {
          $(this).attr('data-ind', i);
        })
    }
    jQuery('.pdp-custom-swatch-list-item').removeClass('active');
    jQuery(this).parent('.pdp-custom-swatch-list-item').addClass('active');
	jQuery('.pdp-custom-styles span.style-click').click(function(){
		var getstyle = $(this).text();
		jQuery('.sek-style-seec').text(getstyle);
	});
	jQuery(document).on('click', '.pdp-swch-img', function() {
		 var getapna = $(this).attr('datache');
		 jQuery('p.selected-swatch-text.desktop.hide_desktop.mobile_fixed.test.new .selected-swatch-text-value').text(getapna);
		 jQuery('p.selected-swatch-text.desktop.hide_desktop.mobile_fixed.test.new').addClass('color-showing');
	});
	var getstyle2 = jQuery('.pdp-custom-styles span.style-click.Selective-style').text();
	jQuery('.sek-style-seec').text(getstyle2);
	jQuery('.thumbnails-options .thumb-img.match-color:first-child').addClass('thumb-img-active');
	jQuery(document).on('click', '.thumbnails-options .thumb-img', function() {
			jQuery('.thumbnails-options .thumb-img').removeClass('thumb-img-active');
			jQuery(this).addClass('thumb-img-active');
	});
    $(document).on('click', '.thumbnails-options .thumb-img', function() {
      let getCurrentIndex = Number($(this).attr('data-ind'));
      $(document).find('.swiper-pagination .swiper-pagination-bullet[data-index="' + (
        getCurrentIndex + 1
      ) + '"]').click();
    })
    const swatchItems = document.querySelectorAll('.pdp-custom-swatch-list-item');
    const styles = document.querySelectorAll('.pdp-custom-styles');
    swatchItems.forEach(item => {
        item.addEventListener('mouseover', () => {
            styles.forEach(style => {
                style.style.zIndex = 0; // Hover par z-index change karna
            });
        });    
        item.addEventListener('mouseout', () => {
            styles.forEach(style => {
                style.style.zIndex = 1; // Mouse out par z-index reset karna
            });
        });
    });
});